import { AllSystemColors, Color, LegacyColor } from '../../utils'
export { ToggleProvider, useModeToggle } from './toggleProvider'
import { IBrand } from '../brandProvider'

export const modes = {
  customer: {
    themeColor: LegacyColor.UIGray,
    background: LegacyColor.LightGray,
    headerBg: LegacyColor.LightGray,
    headerShadow: '0px 7px 24px rgba(0, 0, 0, 0.08)',
    'font-family': 'Sans Serif',
    toggleUncheckColor: LegacyColor.UIGray,
    toggleCheckColor: LegacyColor.Black,
    cardShadow: '0px 7px 24px rgba(160, 160, 160, 0.30)',
    cardBorder: `2px solid ${LegacyColor.Gray}`,
    expandedCardBorder: `1px solid ${LegacyColor.Gray}`,
    ctaColor: LegacyColor.Black,
  },
  teams: {
    themeColor: LegacyColor.LightBlue,
    background:
      'linear-gradient( 180deg, rgba(196, 224, 253, 1) 0%, rgba(196, 224, 253, 1) 16.15%, rgba(196, 224, 253, 1) 29.69%, rgba(196, 224, 253, 1) 40.63%, rgba(196, 224, 253, 0.8) 59.37%, rgba(196, 224, 253, 0.5) 81.77%);',
    headerBg: LegacyColor.LightBlue,
    headerShadow: '0px 7px 24px rgba(50, 107, 255, 0.24)',
    'font-family': 'Pacifico',
    toggleUncheckColor: LegacyColor.LightBlue,
    toggleCheckColor: LegacyColor.Black,
    cardShadow: '0px 7px 24px rgba(50, 107, 255, 0.24)',
    cardBorder: 'none',
    expandedCardBorder: 'none',
    ctaColor: LegacyColor.Blue,
  },
} as const

export const modesDefault = {
  customer: {
    themeColor: Color.UIGray,
    background: Color.Stone,
    headerBg: Color.Stone,
    headerShadow: '0px 7px 24px rgba(0, 0, 0, 0.08)',
    'font-family': 'Sans Serif',
    toggleUncheckColor: Color.UIGray,
    toggleCheckColor: Color.Slate,
    cardShadow: '0px 7px 24px rgba(160, 160, 160, 0.30)',
    cardBorder: `2px solid ${Color.Gray}`,
    expandedCardBorder: `1px solid ${Color.Gray}`,
    ctaColor: Color.Slate,
  },
  teams: {
    themeColor: Color.Sky,
    background: Color.Sky,
    headerBg: Color.Sky,
    headerShadow: '0px 7px 24px rgba(50, 107, 255, 0.24)',
    'font-family': 'Pacifico',
    toggleUncheckColor: Color.Sky,
    toggleCheckColor: Color.Slate,
    cardShadow: '0px 7px 24px rgba(50, 107, 255, 0.24)',
    cardBorder: 'none',
    expandedCardBorder: 'none',
    ctaColor: Color.Blue,
  },
} as const

export const ModeOptions = {
  ...Object.fromEntries(Object.entries(modes).map(([key]) => [key, key])),
} as IAvailableModeOPtions

export const ModeDefaultOptions = {
  ...Object.fromEntries(Object.entries(modesDefault).map(([key]) => [key, key])),
} as IAvailableModeOPtions

export interface IMode {
  themeColor: AllSystemColors
  background: string
  headerBg: AllSystemColors
  headerShadow: string
  'font-family': string
  toggleUncheckColor: AllSystemColors
  toggleCheckColor: AllSystemColors
  cardShadow: string
  cardBorder: string
  expandedCardBorder: string
  ctaColor: AllSystemColors
}

export type IModeOptions = keyof typeof modes

export type IAvailableModeOPtions = {
  [key in IModeOptions]: IModeOptions
}

export interface IContextProps {
  currentMode: IModeOptions | null
  mode: IMode
  setMode: (mode: IModeOptions | null) => void
}

export interface IProps {
  initialMode?: IModeOptions
  brand?: IBrand
}
